import type { TourConfig } from '../types';

export const settingsPageTour: TourConfig = {
  pageId: 'settings',
  pageName: 'Admin Settings',
  portalId: 'crm',
  steps: [
    {
      element: '[data-tour="company-types-config"]',
      title: 'Company Types',
      intro:
        'Manage the list of company types available when creating or editing referral sources. Add, remove, or reorder types.',
      platform: 'both',
      requiredRoles: ['owner', 'admin'],
    },
    {
      element: '[data-tour="save-settings"]',
      title: 'Save Changes',
      intro:
        'After modifying settings, click "Save Changes" to apply. A warning banner appears when you have unsaved changes.',
      platform: 'both',
      requiredRoles: ['owner', 'admin'],
    },
  ],
};
